import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    .MuiPaper-root {
        background: #ecf1f8;
    }
`;
